module.exports = __webpack_public_path__ + "img/6.62f25d8a.jpg";